import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Alert from 'flarum/common/components/Alert';
import Stream from 'flarum/common/utils/Stream';
import Turnstile from './Turnstile';
import { fieldLabel, fieldPlaceholder } from '../../common/config';
export default class ContactForm extends Component {
  name = Stream('');
  email = Stream('');
  subject = Stream('');
  message = Stream('');
  category = Stream('');
  phone = Stream('');
  privacy = Stream(false);
  honeypot = Stream('');
  loading = false;
  errors = {};
  serverError = null;
  startedAt = 0;
  turnstileToken = '';
  turnstileWidget = null;
  turnstileError = null;
  oninit(vnode) {
    super.oninit(vnode);
    this.startedAt = performance.now();
    const config = this.attrs.config;
    const user = app.session.user;
    if (config.prefillAuthenticated && user) {
      this.name(user.displayName() || '');
      this.email(user.email() || '');
    }
    if (config.turnstile.enabled && !config.turnstile.siteKey) {
      this.turnstileError = this.trans('errors.turnstile_unavailable');
    }
  }
  view() {
    const config = this.attrs.config;
    return m("form", {
      className: "Form ContactPage-form",
      onsubmit: e => this.submit(e),
      novalidate: true
    }, this.serverError && m(Alert, {
      type: "error",
      dismissible: false
    }, this.serverError), this.hasRequiredFields() && m("p", {
      className: "ContactPage-requiredNote helpText"
    }, this.trans('required_note')), m("div", {
      className: "ContactPage-formRow"
    }, config.fields.name.enabled && this.renderText('name', 'text', {
      autocomplete: 'name'
    }), config.fields.email.enabled && this.renderText('email', 'email', {
      autocomplete: 'email'
    })), m("div", {
      className: "ContactPage-formRow"
    }, config.fields.subject.enabled && this.renderText('subject', 'text', {
      maxLength: config.subjectMaxLength
    }), config.fields.category.enabled && config.categories.length > 0 && this.renderCategory()), config.fields.phone.enabled && this.renderText('phone', 'tel', {
      autocomplete: 'tel'
    }), config.fields.message.enabled && this.renderMessage(), config.fields.privacy.enabled && this.renderPrivacy(), m("div", {
      className: "ContactPage-honeypot",
      "aria-hidden": "true"
    }, m("input", {
      id: "contact-contact_hp",
      type: "text",
      tabindex: -1,
      autocomplete: "off",
      "aria-hidden": "true",
      value: this.honeypot(),
      oninput: e => this.honeypot(e.target.value)
    })), config.turnstile.enabled && m("div", {
      className: "Form-group ContactPage-turnstileGroup"
    }, m("span", {
      className: "ContactPage-label"
    }, this.trans('turnstile_label')), config.turnstile.siteKey && m(Turnstile, {
      siteKey: config.turnstile.siteKey,
      theme: config.turnstile.theme,
      appearance: config.turnstile.appearance,
      onReady: widget => {
        this.turnstileWidget = widget;
      },
      onToken: token => {
        this.turnstileToken = token;
        this.turnstileError = null;
      },
      onError: () => {
        this.turnstileToken = '';
        this.turnstileError = this.trans('turnstile_error');
        m.redraw();
      },
      onExpire: () => {
        this.turnstileToken = '';
        this.turnstileError = this.trans('turnstile_expired');
        m.redraw();
      }
    }), this.turnstileError && m("p", {
      className: "ContactPage-fieldError",
      role: "alert"
    }, this.turnstileError)), m("div", {
      className: "Form-group Form-controls ContactPage-actions"
    }, m(Button, {
      type: "submit",
      className: "Button Button--primary",
      loading: this.loading,
      disabled: this.loading || !!this.turnstileError
    }, this.loading ? this.trans('sending') : this.trans('submit_button'))));
  }
  renderText(field, type, attrs = {}) {
    const config = this.attrs.config;
    const id = `contact-${field}`;
    const error = this.errors[field];
    const helpId = `${id}-help`;
    const placeholder = fieldPlaceholder(config, field);
    const label = fieldLabel(config, field);
    const required = config.fields[field].required;
    return m("div", {
      className: `Form-group ContactPage-field ${error ? 'ContactPage-field--invalid' : ''}`
    }, m("label", {
      for: id,
      className: "ContactPage-label"
    }, label, required && m("span", {
      className: "ContactPage-required",
      "aria-hidden": "true"
    }, ' ', "*")), m("input", Object.assign({
      id: id,
      type: type,
      className: "FormControl",
      value: this[field](),
      placeholder: placeholder,
      required: required,
      "aria-required": required,
      "aria-invalid": !!error,
      "aria-describedby": error ? helpId : undefined,
      disabled: this.loading,
      oninput: e => {
        this[field](e.target.value);
        if (error) this.clearError(field);
      }
    }, attrs)), error && m("p", {
      id: helpId,
      className: "ContactPage-fieldError",
      role: "alert"
    }, error));
  }
  renderMessage() {
    const config = this.attrs.config;
    const id = 'contact-message';
    const error = this.errors.message;
    const label = fieldLabel(config, 'message');
    const required = config.fields.message.required;
    const length = this.charLength(this.message());
    return m("div", {
      className: `Form-group ContactPage-field ${error ? 'ContactPage-field--invalid' : ''}`
    }, m("label", {
      for: id,
      className: "ContactPage-label"
    }, label, required && m("span", {
      className: "ContactPage-required",
      "aria-hidden": "true"
    }, ' ', "*")), m("textarea", {
      id: id,
      className: "FormControl",
      value: this.message(),
      placeholder: fieldPlaceholder(config, 'message'),
      rows: 8,
      maxlength: config.messageMaxLength,
      required: required,
      "aria-required": required,
      "aria-invalid": !!error,
      "aria-describedby": error ? `${id}-error` : `${id}-count`,
      disabled: this.loading,
      oninput: e => {
        this.message(e.target.value);
        if (error) this.clearError('message');
      }
    }), m("div", {
      className: "ContactPage-messageMeta"
    }, error ? m("p", {
      id: `${id}-error`,
      className: "ContactPage-fieldError",
      role: "alert"
    }, error) : m("span", null), m("span", {
      id: `${id}-count`,
      className: "helpText",
      "aria-live": "polite"
    }, this.trans('character_count', {
      count: length,
      max: config.messageMaxLength
    }))));
  }
  renderCategory() {
    const config = this.attrs.config;
    const id = 'contact-category';
    const error = this.errors.category;
    const label = fieldLabel(config, 'category');
    const required = config.fields.category.required;
    return m("div", {
      className: `Form-group ContactPage-field ${error ? 'ContactPage-field--invalid' : ''}`
    }, m("label", {
      for: id,
      className: "ContactPage-label"
    }, label, required && m("span", {
      className: "ContactPage-required",
      "aria-hidden": "true"
    }, ' ', "*")), m("select", {
      id: id,
      className: "FormControl",
      value: this.category(),
      required: required,
      "aria-required": required,
      "aria-invalid": !!error,
      "aria-describedby": error ? `${id}-error` : undefined,
      disabled: this.loading,
      onchange: e => {
        this.category(e.target.value);
        if (error) this.clearError('category');
      }
    }, m("option", {
      value: ""
    }, this.trans('select_category')), config.categories.map(category => m("option", {
      value: category
    }, category))), error && m("p", {
      id: `${id}-error`,
      className: "ContactPage-fieldError",
      role: "alert"
    }, error));
  }
  renderPrivacy() {
    const config = this.attrs.config;
    const error = this.errors.privacy;
    const id = 'contact-privacy';
    const label = fieldLabel(config, 'privacy');
    const required = config.fields.privacy.required;
    return m("div", {
      className: `Form-group ContactPage-field ContactPage-privacy ${error ? 'ContactPage-field--invalid' : ''}`
    }, m("label", {
      className: "checkbox ContactPage-checkbox",
      for: id
    }, m("input", {
      id: id,
      type: "checkbox",
      checked: !!this.privacy(),
      required: required,
      "aria-required": required,
      "aria-invalid": !!error,
      "aria-describedby": error ? `${id}-error` : undefined,
      disabled: this.loading,
      onchange: e => {
        this.privacy(e.target.checked);
        if (error) this.clearError('privacy');
      }
    }), m("span", null, label, required && m("span", {
      className: "ContactPage-required",
      "aria-hidden": "true"
    }, ' ', "*"))), config.privacyUrl && m("p", {
      className: "ContactPage-privacyLink"
    }, m("a", {
      href: config.privacyUrl,
      target: "_blank",
      rel: "noopener noreferrer"
    }, this.trans('privacy_link'))), error && m("p", {
      id: `${id}-error`,
      className: "ContactPage-fieldError",
      role: "alert"
    }, error));
  }
  submit(e) {
    e.preventDefault();
    if (this.loading) {
      return;
    }
    this.serverError = null;
    this.errors = {};
    const errors = this.validateClient();
    if (Object.keys(errors).length > 0) {
      this.errors = errors;
      this.focusFirstError();
      return;
    }
    const config = this.attrs.config;
    if (config.turnstile.enabled) {
      if (!config.turnstile.siteKey) {
        this.serverError = this.trans('errors.turnstile_unavailable');
        return;
      }
      if (!this.turnstileToken) {
        this.serverError = this.trans('errors.turnstile_missing');
        return;
      }
    }
    const body = {
      elapsedMs: Math.max(0, Math.round(performance.now() - this.startedAt)),
      contact_hp: this.honeypot()
    };
    if (config.fields.name.enabled) body.name = this.name();
    if (config.fields.email.enabled) body.email = this.email();
    if (config.fields.subject.enabled) body.subject = this.subject();
    if (config.fields.message.enabled) body.message = this.message();
    if (config.fields.category.enabled && config.categories.length > 0) body.category = this.category();
    if (config.fields.phone.enabled) body.phone = this.phone();
    if (config.fields.privacy.enabled) body.privacy = this.privacy() ? '1' : '0';
    if (config.turnstile.enabled) body.turnstileToken = this.turnstileToken;
    this.loading = true;
    app.request({
      method: 'POST',
      url: `${app.forum.attribute('apiUrl')}/contact`,
      body,
      errorHandler: error => this.handleError(error)
    }).then(() => {
      this.loading = false;
      this.attrs.onsuccess();
      m.redraw();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
  handleError(error) {
    this.loading = false;
    const errors = error.response?.errors;
    const codes = Array.isArray(errors) ? errors.map(entry => String(entry.code ?? '')) : [];
    const onlyValidationError = error.status === 422 && codes.length > 0 && codes.every(code => code === 'validation_error');

    // A validation error happens before Turnstile is consumed, so keep a valid
    // token for the corrected submission. Every other failure may have consumed
    // or invalidated it, so ask the visitor to verify again.
    if (!onlyValidationError) {
      this.resetTurnstile();
    }
    let general = null;
    if (Array.isArray(errors) && errors.length > 0) {
      errors.forEach(entry => {
        const detail = typeof entry.detail === 'string' ? entry.detail : null;
        const source = entry.source;
        const field = source?.pointer?.split('/').pop();
        if (field && field in this.attrs.config.fields) {
          this.errors[field] = detail || this.trans('errors.generic');
        } else if (detail) {
          general = detail;
        }
      });
    }
    if (!general && Object.keys(this.errors).length === 0) {
      general = this.trans('errors.generic');
    }
    this.serverError = general;
    this.focusFirstError();
    m.redraw();
  }
  validateClient() {
    const config = this.attrs.config;
    const errors = {};
    const checkRequired = (field, value) => {
      if (config.fields[field].enabled && config.fields[field].required && value.trim() === '') {
        errors[field] = this.trans('validation.required', {
          field: fieldLabel(config, field)
        });
      }
    };
    if (config.fields.name.enabled) {
      checkRequired('name', this.name());
      const length = this.charLength(this.name().trim());
      if (this.name().trim() !== '' && length < 2) {
        errors.name = this.trans('validation.name_too_short');
      } else if (length > 100) {
        errors.name = this.trans('validation.name_too_long');
      }
    }
    if (config.fields.email.enabled) {
      checkRequired('email', this.email());
      const email = this.email().trim();
      if (email !== '' && (email.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))) {
        errors.email = this.trans('validation.email_invalid');
      }
    }
    if (config.fields.subject.enabled) {
      checkRequired('subject', this.subject());
      if (this.charLength(this.subject()) > config.subjectMaxLength) {
        errors.subject = this.trans('validation.subject_too_long', {
          max: config.subjectMaxLength
        });
      }
    }
    if (config.fields.message.enabled) {
      checkRequired('message', this.message());
      const length = this.charLength(this.message().trim());
      if (this.message().trim() !== '' && length < config.messageMinLength) {
        errors.message = this.trans('validation.message_too_short', {
          min: config.messageMinLength
        });
      } else if (length > config.messageMaxLength) {
        errors.message = this.trans('validation.message_too_long', {
          max: config.messageMaxLength
        });
      }
    }
    if (config.fields.category.enabled && config.categories.length > 0) {
      checkRequired('category', this.category());
      if (this.category() !== '' && !config.categories.includes(this.category())) {
        errors.category = this.trans('validation.category_invalid');
      }
    }
    if (config.fields.phone.enabled) {
      checkRequired('phone', this.phone());
      if (this.phone().trim() !== '' && !/^[0-9+().\-\s]{3,30}$/.test(this.phone().trim())) {
        errors.phone = this.trans('validation.phone_invalid');
      }
    }
    if (config.fields.privacy.enabled && config.fields.privacy.required && !this.privacy()) {
      errors.privacy = this.trans('validation.privacy_required', {
        field: fieldLabel(config, 'privacy')
      });
    }
    return errors;
  }
  hasRequiredFields() {
    const config = this.attrs.config;
    return Object.keys(config.fields).some(field => config.fields[field].enabled && config.fields[field].required && (field !== 'category' || config.categories.length > 0));
  }
  clearError(field) {
    delete this.errors[field];
    m.redraw();
  }
  resetTurnstile() {
    this.turnstileToken = '';
    this.turnstileError = null;
    this.turnstileWidget?.reset();
  }
  focusFirstError() {
    const field = Object.keys(this.errors)[0];
    if (!field) {
      return;
    }
    window.setTimeout(() => {
      document.getElementById(`contact-${field}`)?.focus();
    }, 0);
  }
  trans(key, params = {}) {
    return app.translator.trans(`cengizkemec-contact-page.forum.${key}`, params, true);
  }
  charLength(value) {
    return Array.from(value).length;
  }
}
flarum.reg.add('cengizkemec-contact-page', 'forum/components/ContactForm', ContactForm);